import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './index.css';
import 'delic-ui/dist/index.css';

const renderMaintenance = () => {
    ReactDOM.render(
        <main style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '32px',
            background: '#f7f9fb',
            color: '#17202a',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'center'
        }}>
            <section style={{
                maxWidth: '560px'
            }}>
                <h1 style={{
                    margin: '0 0 16px',
                    fontSize: 'clamp(2rem, 5vw, 3rem)',
                    fontWeight: 700,
                    lineHeight: 1.15
                }}>
                    Streamline is temporarily unavailable
                </h1>
                <p style={{
                    margin: 0,
                    fontSize: '1.125rem',
                    lineHeight: 1.6
                }}>
                    We’re completing scheduled maintenance and will be back shortly. Please check back soon.
                </p>
            </section>
        </main>,
        document.getElementById('root')
    )
}

const renderApp = () => {
    const App = require('./App').default;
    const { Provider } = require('react-redux');
    const { default: store, history } = require('./store');
    const { ConnectedRouter } = require('connected-react-router/immutable');
    const { bootstrapDownloadTransfers } = require('./downloadTransfer/downloadHydration');
    const { bootstrapUploadTransfers } = require('./uploadTransfer/uploadHydration');

    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root')
    )

    bootstrapDownloadTransfers({ store });
    bootstrapUploadTransfers({ store });
}

if (process.env.REACT_APP_MAINTENANCE_ENABLED === "true") {
    renderMaintenance();
} else {
    const Amplify = require('@aws-amplify/core').default;
    const Auth = require('@aws-amplify/auth').default;

    const rawEnv = process.env.REACT_APP_ENV;
    const env = rawEnv === "prod" || rawEnv === "stage" || rawEnv === "dev" ? rawEnv : "dev";
    const aws_exports = env === "prod"
        ? require("./aws-exports.prod").default
        : env === "stage"
            ? require("./aws-exports.stage").default
            : require("./aws-exports.dev").default;

    // ENABLE DEBUG MODE
    // window.LOG_LEVEL = "DEBUG";

    // This is needed so that we can google login from localhost https://github.com/aws-amplify/amplify-cli/issues/2792
    if (process.env.NODE_ENV === "development") {
        aws_exports.oauth.redirectSignIn = `${window.location.origin}/`;
        aws_exports.oauth.redirectSignOut = `${window.location.origin}/`;

        // Amplify.Logger.LOG_LEVEL = 'DEBUG';
    }

    aws_exports.oauth.domain = process.env.REACT_APP_OAUTH_DOMAIN;

    Amplify.configure(aws_exports);
    Amplify.configure({
        API: {
            graphql_endpoint: process.env.REACT_APP_DELIC_DATA_ENDPOINT,
            graphql_endpoint_iam_region: 'eu-west-1',
            endpoints: [
                {
                    name: "DelicPaymentAPI",
                    endpoint: process.env.REACT_APP_DELIC_PAYMENT_API
                },
            ]
        }
    })
    Auth.configure(aws_exports)

    renderApp()

    if (process.env.NODE_ENV === 'development' && module.hot) {
        module.hot.accept('./App', renderApp)
    }

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

// trigger rebuild
